import i18n from '@/lang/i18n'
import { DashboardModuleArea, DashboardModuleLayoutWidget, DashboardModuleSectionsWidgets } from '@/modules/dashboard-module/shared/models/dashboard-module.model'
import { StrictNullable } from '@/shared/types/app.types'

export interface DashboardComponentsSidebarAddWidgetsFilterWidgets {
    list: DashboardModuleSectionsWidgets[],
    selected: StrictNullable<DashboardModuleSectionsWidgets>
}

export interface DashboardComponentsSidebarAddWidgetsWidgetCategories {
    id: DashboardModuleArea
    name: string
    visible: boolean
    widgets: DashboardModuleLayoutWidget[]
}

export interface DashboardComponentsSidebarAddWidgetsState {
    unsubscribe: Function
    show: boolean
    filter: DashboardComponentsSidebarAddWidgetsFilterWidgets
    categories: DashboardComponentsSidebarAddWidgetsWidgetCategories[]
}
export const initialDashboardComponentsSidebarAddWidgetsState =
    (): DashboardComponentsSidebarAddWidgetsState => ({
        show: false,
        filter: {
            selected: null,
            list: []
        },
        categories: [
            {
                id: DashboardModuleArea.PENDING_ELEMENTS,
                name: i18n.tc('dashboard.sidebar.pendingElements'),
                visible: true,
                widgets: []
            },
            {
                id: DashboardModuleArea.CHARTS,
                name: i18n.tc('dashboard.sidebar.charts'),
                visible: true,
                widgets: []
            },
            {
                id: DashboardModuleArea.INTEREST_DATA,
                name: i18n.tc('dashboard.sidebar.interestingData'),
                visible: true,
                widgets: []
            },
            {
                id: DashboardModuleArea.UTILITIES,
                name: i18n.tc('dashboard.sidebar.utilities'),
                visible: true,
                widgets: []
            }
        ],
        unsubscribe: () => {}
    })
